import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuthStore from '../../store/authStore';
import toast from 'react-hot-toast';

export default function LoginPage() {
  const navigate = useNavigate();
  const { login, isLoading } = useAuthStore();
  const [form, setForm] = useState({ email: '', password: '' });
  const [errors, setErrors] = useState({});

  function validate() {
    const errs = {};
    if (!form.email) errs.email = 'E-mail obrigatório';
    else if (!/\S+@\S+\.\S+/.test(form.email)) errs.email = 'E-mail inválido';
    if (!form.password) errs.password = 'Senha obrigatória';
    return errs;
  }

  async function handleSubmit(e) {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length) { setErrors(errs); return; }
    setErrors({});

    const result = await login(form.email, form.password);
    if (result.success) {
      toast.success('Login realizado com sucesso!');
      navigate('/admin/dashboard');
    } else {
      toast.error(result.error);
    }
  }

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <a href="/" style={styles.backLink}>← Voltar para a home</a>
        <div style={styles.logoWrap}>
          <div style={styles.logo}>
            <span style={styles.logoIcon}>📦</span>
          </div>
          <h1 style={styles.brand}>BringHub Frete</h1>
          <p style={styles.subtitle}>Painel Administrativo</p>
        </div>

        <form onSubmit={handleSubmit} style={styles.form} noValidate>
          <div style={styles.field}>
            <label style={styles.label}>E-mail</label>
            <input
              type="email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              placeholder="admin@bringhubfrete.com.br"
              style={{ ...styles.input, ...(errors.email ? styles.inputError : {}) }}
              autoComplete="email"
            />
            {errors.email && <span style={styles.errorMsg}>{errors.email}</span>}
          </div>

          <div style={styles.field}>
            <label style={styles.label}>Senha</label>
            <input
              type="password"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              placeholder="••••••••"
              style={{ ...styles.input, ...(errors.password ? styles.inputError : {}) }}
              autoComplete="current-password"
            />
            {errors.password && <span style={styles.errorMsg}>{errors.password}</span>}
          </div>

          <button type="submit" disabled={isLoading} style={styles.button}>
            {isLoading ? (
              <span style={styles.spinner}>Entrando...</span>
            ) : (
              'Entrar no Painel'
            )}
          </button>
        </form>

        <p style={styles.hint}>
          Acesso restrito a administradores do sistema
        </p>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #1e3a8a 0%, #1e40af 50%, #2563eb 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '24px',
  },
  card: {
    background: '#ffffff',
    borderRadius: '16px',
    padding: '48px 40px',
    width: '100%',
    maxWidth: '420px',
    boxShadow: '0 25px 50px -12px rgba(0,0,0,0.25)',
  },
  logoWrap: {
    textAlign: 'center',
    marginBottom: '36px',
  },
  logo: {
    width: '64px',
    height: '64px',
    background: 'linear-gradient(135deg, #1e40af, #3b82f6)',
    borderRadius: '16px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '16px',
  },
  logoIcon: { fontSize: '28px' },
  brand: {
    fontSize: '24px',
    fontWeight: '700',
    color: '#111827',
    letterSpacing: '-0.5px',
  },
  subtitle: {
    fontSize: '14px',
    color: '#6b7280',
    marginTop: '4px',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
  field: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
  },
  label: {
    fontSize: '14px',
    fontWeight: '500',
    color: '#374151',
  },
  input: {
    padding: '12px 14px',
    border: '1.5px solid #d1d5db',
    borderRadius: '8px',
    fontSize: '15px',
    color: '#111827',
    outline: 'none',
    transition: 'border-color 0.15s',
    backgroundColor: '#f9fafb',
  },
  inputError: {
    borderColor: '#dc2626',
    backgroundColor: '#fef2f2',
  },
  errorMsg: {
    fontSize: '12px',
    color: '#dc2626',
    fontWeight: '500',
  },
  button: {
    marginTop: '8px',
    padding: '13px',
    background: 'linear-gradient(135deg, #1e40af, #2563eb)',
    color: '#ffffff',
    border: 'none',
    borderRadius: '8px',
    fontSize: '15px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'opacity 0.15s',
    letterSpacing: '0.2px',
  },
  spinner: {
    opacity: 0.8,
  },
  hint: {
    textAlign: 'center',
    marginTop: '24px',
    fontSize: '12px',
    color: '#9ca3af',
  },
  backLink: {
    display: 'inline-block',
    marginBottom: '24px',
    fontSize: '13px',
    color: '#6b7280',
    textDecoration: 'none',
    fontWeight: '500',
  },
};
